var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45456 18.5303V9.18253L2.57878 6.53036L0 5.05859V16.8807C0 17.7934 0.733594 18.5303 1.63641 18.5303H5.45456Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 18.5302H22.3636C23.2691 18.5302 24 17.7906 24 16.8806V5.05859L21.0791 6.74433L18.5454 9.18244V18.5302Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45456 9.18237L5.06325 5.52993L5.45456 2.03418L12 6.98298L18.5454 2.03418L18.9832 5.3412L18.5454 9.18237L12 14.1312L5.45456 9.18237Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 2.03412V9.18231L24 5.05837V2.85889C24 0.818937 21.69 -0.343982 20.0728 0.879422L18.5454 2.03412Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.05841L2.50866 6.95518L5.45456 9.18235V2.03416L3.92719 0.879465C2.30719 -0.344033 0 0.81898 0 2.85884V5.05832V5.05841Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.24,
    fill: "white",
    transform: "translate(0 0.379883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/gmail-logo.ef0794c43a419fac861d970296fdaeca.svg";
export { ForwardRef as ReactComponent };